'use client';

import { useEffect } from 'react';

import { runWhenIdle } from '@/src/lib/utils/runWhenIdle';

const IDLE_TIMEOUT_MS = 4000;
const FALLBACK_DELAY_MS = 1000;

export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    // Never run the PWA service worker in development.
    //
    // `public/sw.js` serves `/_next/static/*` cache-first, which is correct in
    // production (chunk filenames are content-hashed, so a cached chunk is
    // immutable) but actively breaks dev: dev chunks are rebuilt in place on
    // every edit, so the SW hands the browser a STALE chunk while the dev
    // server has a freshly-built RSC client-reference manifest. The client then
    // tries to require a module id the stale chunk doesn't define, throwing
    // `TypeError: Cannot read properties of undefined (reading 'call')` deep in
    // the webpack runtime — and because the staleness lives in the browser's
    // Cache Storage, it survives `.next` wipes, reinstalls, and dev restarts.
    //
    // So in dev we both skip registration AND proactively tear down any SW +
    // `hotpads-*` caches left behind by a production visit or an earlier build,
    // so a developer's environment self-heals on the next load instead of
    // needing a manual DevTools "Unregister + Clear site data".
    if (process.env.NODE_ENV !== 'production') {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
      if (typeof caches !== 'undefined') {
        caches.keys().then((keys) => {
          keys.filter((key) => key.startsWith('hotpads-')).forEach((key) => caches.delete(key));
        });
      }
      return;
    }

    const register = () => {
      navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' }).catch((err) => {
        console.error('Service worker registration failed:', err);
      });
    };

    return runWhenIdle(register, { timeoutMs: IDLE_TIMEOUT_MS, fallbackDelayMs: FALLBACK_DELAY_MS });
  }, []);

  return null;
}
